import React, {useEffect, useState} from 'react'
import DeckApi from '../logic/DeckApi'
import {Deck} from '../model/models'
import {useNavigate} from 'react-router-dom'
import DeckMasonry from '../components/DeckMasonry'
import AnonAddDeckDialog from '../components/AnonAddDeckDialog'
import {useSnackbar} from 'notistack'
import {useAuth} from '../components/auth/AuthProvider'
import LoadingBackdrop from '../components/LoadingBackdrop'

const api = new DeckApi()

export default function PublicDecks() {
  const [loading, setLoading] = useState<boolean>(true)
  const [loadingOverlay, setLoadingOverlay] = useState<boolean>(false)
  const [decks, setDecks] = useState<Deck[] | null>(null)
  const [loginSignupOpen, setLoginSignupOpen] = useState<boolean>(false)
  const {user} = useAuth()
  const isAnon = user === null

  const navigate = useNavigate()
  const {enqueueSnackbar} = useSnackbar()

  const addPublicDeck = async (deckId: number) => {
    if (loadingOverlay) return
    setLoadingOverlay(true)
    
    const res = await api.copyDeck(deckId)
    if (res.isError()) {
      setLoadingOverlay(false)
      console.error('error copying deck', res.exception?.toJson())
      enqueueSnackbar('Error copying deck', {variant: 'error'})
      return
    }
    
    enqueueSnackbar('Copied deck', {variant: 'success'})
    navigate('/redirect/public-decks')
  }

  const addPublicDeckAnon = (deckId: number) => {
    setLoginSignupOpen(true)
  }

  const closeAnonDialog = () => {
    setLoginSignupOpen(false)
  }

  useEffect(() => {
    let isCanceled = false

    api.getPublicDecksWithoutCards().then(decksResponse => {
      if (decksResponse.isError()) {
        console.error('error getting decks', decksResponse.exception?.toJson())
        navigate('/error')
        return
      }
      const decks = decksResponse.data!
      setDecks(decks)
    }).finally(() => {
      if (!isCanceled) setLoading(false)
    })

    return () => {
      isCanceled = true
    }
  }, [])

  return (
    <>
      <LoadingBackdrop loading={loadingOverlay}/>
      <AnonAddDeckDialog deckId={-1} open={loginSignupOpen} handleCloseCancel={closeAnonDialog}/>
      <DeckMasonry
        title="Public Decks"
        loading={loading}
        decks={decks || []}
        isPublic
        onAddPublic={isAnon ? addPublicDeckAnon : addPublicDeck}
        isAnon={isAnon}
        hidePublicDecksLink
      />
    </>
  )
}
